import { NavigationTabContainer } from '@/components/common';
import { DetailsWrapper } from '@/property-details/components/property-details-content-styles';
import { BackButton } from '@/widgets/components/back-button';
import { CleanModal } from '@/widgets/components/clean-modal';
import styled from 'styled-components';
import { ComplaintFiles } from './complaint-files';
import { ComplaintReport } from './complaint-report';
import { ComplaintStats } from './complaint-stats';
import { TComplaintData, TUpdateComplaintStatusFn } from './types';

const ComplaintNumber = styled.div`
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #101938;
  width: 100%;
  margin-bottom: 20px;
`;

const ComplaintDetails = styled(DetailsWrapper)`
  /**
    Use full width when the "History & Notes" section is implemented
    Wireframes
    https://www.figma.com/file/DfMWS8vuuQsj3ESiKZM6GQ/Complaints-MVP?type=design&node-id=67-276&mode=design&t=Fwes0cQ5kIpD8x6S-0
  */
  /* width: 100%; */
  width: 800px;
  flex-direction: column;
`;

type TListedComplaintModalProps = {
  complaintData: TComplaintData;
  updateComplaintStatus: TUpdateComplaintStatusFn;
  currentComplaintId?: number;
};

export function ListedComplaintModal(props: TListedComplaintModalProps) {
  const { currentComplaintId, complaintData, updateComplaintStatus } = props;

  return (
    <CleanModal active={Boolean(currentComplaintId)}>
      <NavigationTabContainer>
        <BackButton label="To List" />
      </NavigationTabContainer>

      <ComplaintDetails data-cy="complaint-details">
        <ComplaintNumber data-cy="complaint-details-complaint-number">
          Complaint #{complaintData.complaintId}
        </ComplaintNumber>

        <ComplaintStats
          complaintData={complaintData}
          updateComplaintStatus={updateComplaintStatus}
        />

        <ComplaintReport complaintData={complaintData} />

        <ComplaintFiles files={complaintData.files} />
      </ComplaintDetails>
    </CleanModal>
  );
}
